import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import Navbar from '../components/layout/Navbar'
import Footer from '../components/layout/Footer'
import { usePageMeta } from '../hooks/usePageMeta'

function PricingPage() {
  usePageMeta({
    title: 'Rithmo Pricing: Free to Get Started',
    description: 'Start free with Rithmo. AI meeting governance with agenda enforcement, talk equity tracking, and structured outputs. No credit card required.',
  })
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <main className="pt-24">
        <section className="relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-primary-50/60 via-white to-white" />
          <div className="absolute -top-20 right-10 w-80 h-80 bg-accent-500/10 rounded-full blur-3xl" />
          <div className="absolute bottom-0 left-10 w-80 h-80 bg-primary-500/10 rounded-full blur-3xl" />

          <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-center"
            >
              <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-4">
                Pricing
              </h1>
              <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto mb-8">
                Get started for free. No credit card required. Cancel anytime.
              </p>
              <div className="flex justify-center">
                <Link to="/signup" className="btn-primary text-lg px-8 py-4">
                  Get Started for Free
                </Link>
                {/* <Link to="/contact" className="btn-secondary text-lg px-8 py-4">
                  Contact Sales
                </Link> */}
              </div>
            </motion.div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  )
}

export default PricingPage
